import React, { useEffect } from 'react';
import Introduction from '../components/views/Intro/intro';
import About from '../components/views/About/About';
import Education from '../components/views/Education/Education';
import Experience from '../components/views/Experience/Experience';
import Skills from '../components/views/Skills/Skills';
import Projects from '../components/views/Projects/Projects';
import AgenticAI from '../components/views/AgenticAI/AgenticAI';
import Blogs from '../components/views/Blogs/Blogs';
import Contact from '../components/views/Contact/Contact';

const HomePage = () => {
  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, '');
    if (!hash) return;
    requestAnimationFrame(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
    });
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll('section');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('section-in-view');
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.08 }
    );
    sections.forEach((section) => observer.observe(section));
    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <>
      <Introduction />
      <About />
      <Education />
      <Experience />
      <Skills />
      <Projects />
      <AgenticAI />
      <Blogs />
      <Contact />
    </>
  );
};

export default HomePage;
